import React from "react";
import {ClientCreationResponseDto} from "../../types";

export const ClientCredentialsContent: React.FC<{ clientCredentials: ClientCreationResponseDto }> = ({ clientCredentials }) => {

  return (
    <div data-testid='client-credentials' className="status-message status-confirm">
      <h2>Client Credentials:</h2>
      <br/>
      <p><b>Client ID:</b> {clientCredentials.clientId}</p>
      <p><b>Client Secret:</b> {clientCredentials.clientSecret}</p>
      <br/>
      <button className='button-primary'><a href={'/clients'}>I copied everything</a></button>
    </div>
  )
};

export default ClientCredentialsContent;
